export default __webpack_public_path__ + "3540f6e3a962aaef655cd015e2dad447.png";